import { TipoDanno } from './tipo-danno';
import { Model } from './model';

export class GruppoTipiDanno extends Model {
    static apiUrl: string = "gruppi_tipi_danno";

    nome: string;
    descrizione: string;
    tipi_danno: TipoDanno[];

    deserialize(input: any): GruppoTipiDanno {
        let retV: GruppoTipiDanno = new GruppoTipiDanno();

        retV = super.deserialize(input) as GruppoTipiDanno;

        if (input?.tipi_danno) {
            retV.tipi_danno = input.tipi_danno.map(m => new TipoDanno().deserialize(m));
        }


        return retV;
    }

}
